module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--sidebar group--df-column"
  }, [_c('div', {
    staticClass: "group group--df group--wide"
  }, [_c('div', [_c('h1', {
    staticClass: "h1 group__title mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.pageTitle)
    }
  }), _vm._v(" "), (_vm.selectedAppointmentType === "video" && !_vm.queryData) ? _c('p', {
    staticClass: "p group__description"
  }, [_vm._v("Come back and log in five minutes before your scheduled start time, then click the video chat link to begin.")]) : _vm._e(), _vm._v(" "), (_vm.selectedAppointmentType === "phone" && !_vm.queryData) ? _c('p', {
    staticClass: "p group__description"
  }, [_vm._v("Your counselor will call you directly at " + _vm._s(_vm.userPhone) + ".")]) : _vm._e(), _vm._v(" "), (_vm.f2fSelected) ? _c('p', {
    staticClass: "p group__description"
  }, [_vm._v("We’ve forwarded your details on to our team, and we’ll contact you shortly.")]) : _vm._e(), _vm._v(" "), (!_vm.isNewUser) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "link": _vm.buttonContent.link,
      "label": _vm.buttonContent.label
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNewUser) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Go to login",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetAndRedirect.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "illustration illustration--success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (!_vm.f2fSelected && !_vm.queryData) ? _c('div', [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("How should I get ready?")]), _vm._v(" "), _c('p', {
    staticClass: "p mw640 mt0"
  }, [_vm._v("Find a quiet, comfortable spot where you can speak privately. Make sure there’s a strong internet signal and enough light so the counselor can see your face.")]), _vm._v(" "), (_vm.selectedAppointmentType === "video") ? _c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Can I video chat with a tablet or cell phone?")]) : _vm._e(), _vm._v(" "), (_vm.selectedAppointmentType === "video") ? _c('p', {
    staticClass: "p mw640 mt0"
  }, [_vm._v("Sure. You can use whatever device you prefer.")]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("What should I expect?")]), _vm._v(" "), _c('p', {
    staticClass: "p mw640 mt0"
  }, [_vm._v("A conversation. It’ll just be you and your counselor, so the two of you will be able to talk openly about what’s going on to figure out helpful next steps.")]), _vm._v(" "), (_vm.selectedAppointmentType === "video") ? _c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("What if I miss the video chat start time?")]) : _vm._e(), _vm._v(" "), (_vm.selectedAppointmentType === "video") ? _c('p', {
    staticClass: "p mw640 mt0"
  }, [_vm._v("If you’re just a few minutes late, you can still log in and join. If you miss your session entirely, please call "), _c('a', {
    staticClass: "tdn",
    attrs: {
      "href": ("tel:" + (_vm.org.phone))
    }
  }, [_vm._v(_vm._s(_vm.org.phone))]), _vm._v(" and we’ll find another time for you and your counselor to talk.")]) : _vm._e(), _vm._v(" "), (_vm.selectedAppointmentType === "phone") ? _c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("What if I miss my call?")]) : _vm._e(), _vm._v(" "), (_vm.selectedAppointmentType === "phone") ? _c('p', {
    staticClass: "p mw640 mt0"
  }, [_vm._v("Please call "), _c('a', {
    staticClass: "tdn",
    attrs: {
      "href": ("tel:" + (_vm.org.phone))
    }
  }, [_vm._v(_vm._s(_vm.org.phone))]), _vm._v(" and we’ll find another time for you and your counselor to talk.")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af592ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/RegisterSuccess.vue
// module id = 483
// module chunks = 0